module.exports = __webpack_public_path__ + "static/media/dianzan.07d12892.svg";